import CouponMarketplaceCouponTokensGroupByCoupon from './coupon-marketplace-coupon-tokens-group-by-coupon-view'

export default CouponMarketplaceCouponTokensGroupByCoupon
